const TOUCH_MOUSE_GUARD_MS = 500;

type HoldRepeatOptions = {
	startDelayMs: number;
	intervalMs: number;
	minIntervalMs?: number;
	accelerationMs?: number;
};

export const createHoldRepeat = ({
	startDelayMs,
	intervalMs,
	minIntervalMs = intervalMs,
	accelerationMs = 0,
}: HoldRepeatOptions) => {
	let timer: ReturnType<typeof setTimeout> | null = null;
	let lastTouchTime = 0;

	const stop = () => {
		if (timer) clearTimeout(timer);
		timer = null;
	};

	const start = (onStep: () => void) => {
		stop();
		onStep();

		let delay = intervalMs;
		const run = () => {
			onStep();
			delay = Math.max(minIntervalMs, delay - accelerationMs);
			timer = setTimeout(run, delay);
		};

		timer = setTimeout(run, startDelayMs);
	};

	const startFromMouse = (onStep: () => void) => {
		if (Date.now() - lastTouchTime < TOUCH_MOUSE_GUARD_MS) return;
		start(onStep);
	};

	const startFromTouch = (onStep: () => void) => {
		lastTouchTime = Date.now();
		start(onStep);
	};

	return { startFromMouse, startFromTouch, stop };
};
